/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 8821eb4db77d
 */

import * as z from "zod";
import {
  StreamingProfile,
  StreamingProfile$zodSchema,
} from "./streamingprofile.js";

export type StreamingProfileListResponse = { data: Array<StreamingProfile> };

export const StreamingProfileListResponse$zodSchema: z.ZodType<
  StreamingProfileListResponse
> = z.object({
  data: z.array(StreamingProfile$zodSchema),
});
